export const GROUPING_SETTINGS_PREFIX = 'reportGroups' as const;
export const DEFAULT_SETTINGS = {
    reportGroups: {},
    groupAfterUserFilter: false,
    usingGroup: true,
};
